import axiosInstance from '../../../config/axiosInstance';
const DashboardService = {
    async SaleOrderDashboard(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/SaleOrderDashboard?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async MonthlySaleOrderDashboard(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/MonthlySaleOrderDashboard?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async MonthlyPurchaseOrder(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/MonthlyPurchaseOrder?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async MonthWisePurchaseOrder(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/MonthWisePurchaseOrder?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DashboardReport(UserID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/DashboardReport?ClientID=${ClientID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async getDashboardReports(ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/getDashboardReports?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async saveDashboardConfig(UserID, chartConfigs) {
        try {
            const response = await axiosInstance.post(`/Dashboard/saveDashboardConfig`, {
                UserID,
                chartConfigs
            });
            return response.data;
        } catch (error) {
            console.error("Error saving dashboard config:", error);
            throw error;
        }
    },
    async saveDashboardSections(UserID, value) {
        try {
            const response = await axiosInstance.get(`/Dashboard/saveDashboardSections?UserID=${UserID}&Sections=${value}`);
            return response.data;
        } catch (error) {
            console.error("Error saving dashboard config:", error);
            throw error;
        }
    },
    async GetDashboardSections(UserID) {
        try {
            const response = await axiosInstance.get(`/Dashboard/GetDashboardSections?UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error("Error saving dashboard config:", error);
            throw error;
        }
    },
    async GetApiDetail() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetApiDetail?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error("Error saving dashboard config:", error);
            throw error;
        }
    }
};

export default DashboardService;